import React, { Component } from 'react'
import { DragSource } from 'react-dnd'

const itemSource = {
    beginDrag(props) {

		if(props.showDropzones) {
			props.showDropzones(props.type)
		}

		return {			
            index: props.index,
			id: props.id,
			type: props.type,
            listId: props.listID
		};
	},

	endDrag(props) {
		if(props.hideDropzones) {
			props.hideDropzones()
		}
	}
}

@DragSource(props => (props.dndType), itemSource, (connect, monitor) => ({
	connectDragSource: connect.dragSource(),
	isDragging: monitor.isDragging(),
}))

class DragSourceWrapperContainer extends Component {
	
	render() {
		const { children, connectDragSource } = this.props

		return connectDragSource(
			<div>
				{children}
			</div>
		)
	}
}

export default DragSourceWrapperContainer